import React from 'react'
import "./main.css"
const Footer = () => {
  return (
    
    <section class="footer">
    <div class="box-container">

        <div className="box">
            <h3>About us</h3>
            <p className="des">Amcouch by amcoindustries.net, we are a leading memory foam manufacturer based in Gurgaon, dedicated to delivering comfort through innovation. With a focus on quality, durability, and ergonomic design!</p>
        </div>
      <div class="box">
        <h3>Quick links</h3>
        <a href="/">Home</a>
        <a href="/#about">About</a>
        <a href="/products">products</a>
        <a href="/#trending">Trending</a>
        <a href="/#contact">contact</a>
      </div>

      <div class="box">
        <h3>Extra links</h3>
        <a href="/#contact">Book Appointment</a>
        <a href="/prodcuts">Order Sample</a>
        <a href="/#contact">Report bugs</a>
      </div>

     

      <div class="box">
        <h3>Contact info</h3>
        <a href="tel:+919811192812">+91 9811192812</a>
        <a href="mailto:amcoindus@gmail.com">amcoindus@gmail.com</a>
        <a href="/#contact">gurgaon, india - 122001</a>
      </div>
    </div>

    <div class="credit">
      {" "}
      All rights reserved <span> Amcouch by amco industries </span> @2025{" "}
    </div>
  </section>
  )
}

export default Footer